module.exports = setImmediate



//////////////////
// WEBPACK FOOTER
// ./node_modules/memdown/immediate.js
// module id = 304
// module chunks = 0